import { createContext } from "react";
import * as firebase from "firebase/app";

const UserContext = createContext((null as unknown) as firebase.User | null);

export default UserContext;
